module.exports = __webpack_public_path__ + "img/ylb-10.8d91e205.png";